"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListItemStyles = exports.listItemVars = exports.listItemCommon = void 0;
var _tinycolor = require("@ctrl/tinycolor");
var _createUseStyles = _interopRequireDefault(require("../../../themes/createUseStyles"));
var _getContrastingTextColor = require("../../../utils/getContrastingTextColor");
var _commonProps = require("../../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var listItemCommon = exports.listItemCommon = _commonProps.defaultCommonProps;
var listItemVars = exports.listItemVars = (0, _initVars.default)({
  applied: listItemCommon,
  variables: [{
    key: "rootColor"
  }]
});
var styles = function styles(theme) {
  var selectedItemColor = (0, _getContrastingTextColor.getContrastingTextColorHexString)(new _tinycolor.TinyColor(theme.colors.primary).darken(7), undefined, undefined, _getContrastingTextColor.PRIMARY_CONTRAST_STANDARD);
  return {
    variables: listItemVars.styles,
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      position: "relative",
      listStyleType: "none",
      width: "100%",
      outline: 0,
      textDecoration: "none",
      transition: "background 250ms",
      userSelect: "none",
      cursor: "pointer",
      boxSizing: "border-box",
      fontFamily: theme.typography.fontFamily,
      lineHeight: theme.typography.lineHeight,
      minHeight: theme.spacing.base * 4,
      padding: [0, theme.spacing.base],
      marginBottom: 0,
      fontSize: theme.typography.fontSize,
      fontWeight: theme.typography.fontWeight,
      color: listItemVars.get("rootColor"),
      flexDirection: "row",
      "& > svg": {
        pointerEvents: "none",
        fill: theme.colors.baseContrast070,
        minWidth: theme.spacing.base * 3,
        minHeight: theme.spacing.base * 3,
        marginInlineStart: theme.spacing.base,
        marginInlineEnd: theme.spacing.base / 2,
        transition: "fill 250ms"
      },
      "&:focus-visible, &:hover": {
        background: theme.colors.baseContrast020,
        color: theme.colors.baseContrast100,
        "& svg": {
          fill: theme.colors.baseContrast100
        }
      },
      "&:focus-visible": {
        background: theme.colors.baseContrast020
      }
    },
    reverse: {
      flexDirection: "row-reverse",
      "& > svg": {
        marginInlineStart: theme.spacing.base,
        marginInlineEnd: theme.spacing.base
      }
    },
    primaryText: {
      padding: "0px ".concat(theme.spacing.base * 2, "px"),
      pointerEvents: "none",
      fontFamily: "inherit"
    },
    primaryTextIconPadding: {
      padding: "0px ".concat(theme.spacing.base, "px")
    },
    secondaryText: {
      fontFamily: "inherit",
      fontSize: theme.typography.fontSize - 3,
      color: theme.colors.baseContrast060,
      pointerEvents: "none",
      marginInlineStart: "auto",
      paddingInlineEnd: theme.spacing.base * 2
    },
    secondaryTextReverse: {
      marginInlineEnd: "auto",
      marginInlineStart: 0,
      paddingInlineStart: theme.spacing.base * 2
    },
    disabled: {
      pointerEvents: "none",
      "& span": {
        color: theme.colors.baseContrast050
      },
      "& svg": {
        fill: theme.colors.baseContrast030
      }
    },
    tall: {
      "li&": {
        height: theme.spacing.base * 6
      }
    },
    selected: {
      background: theme.colors.primary,
      "& span": {
        color: selectedItemColor
      },
      "& svg": {
        fill: selectedItemColor
      },
      "&:focus-visible, &:hover": {
        background: theme.colors.primary,
        "& svg": {
          fill: selectedItemColor
        }
      },
      "&:focus-visible": {
        background: theme.colors.primary
      }
    }
  };
};
var useListItemStyles = exports.useListItemStyles = (0, _createUseStyles.default)(styles, {
  name: "ListItem"
});